// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import "./i18n";
// import { initPageTranslate } from "./utils/pageTranslate";
// import { initMobileImages } from "./utils/mobileImages";
// import reportWebVitals from './reportWebVitals';

// initPageTranslate();
// initMobileImages();

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();




import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import './index.css';
import App from './App';
import './i18n';
import { initPageTranslate } from './utils/pageTranslate';
import { initMobileImages } from './utils/mobileImages';
import reportWebVitals from './reportWebVitals';

initPageTranslate();
initMobileImages();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
